// Site-wide content data for Leamington Gutters
export const SITE = {
  business: 'Leamington Gutters',
  tagline: 'Guttering & Fascia Services',
  contactName: 'Luke',
  phone: '07788287003',
  phoneDisplay: '07788 287 003',
  phoneTel: 'tel:+447788287003',
  email: 'leamingtonguttersuk@gmail.com',
  emailHref: 'mailto:leamingtonguttersuk@gmail.com',
  location: 'Leamington Spa, Warwickshire',
};

// Original flyer source — used for logo & gallery crops
export const FLYER_URL =
  'https://customer-assets.emergentagent.com/job_8d21097c-227f-4593-8fe9-c66b7c8b77c3/artifacts/bl0zfzz1_Magazine%20ad%20landscape.png';

export const SERVICES = [
  {
    title: 'Full UPVC Replacement',
    short: 'Gutter, fascia & soffit',
    description:
      'Complete supply and fit of new UPVC gutters, fascias and soffits in a range of colours and profiles. Tidy, weather-tight, built to last.',
    icon: 'House',
  },
  {
    title: 'Leaking Gutter Repair',
    short: 'Repair & replacement',
    description:
      'We track down the source of leaks at joints, brackets and downpipes — then repair or replace the affected sections so water flows where it should.',
    icon: 'Wrench',
  },
  {
    title: 'Gutter Moss Removal',
    short: 'Clear, free-flowing gutters',
    description:
      'Stubborn moss, silt and seedlings cleared by hand and vacuum — protecting your fascias, soffits and brickwork from water damage.',
    icon: 'Sprout',
  },
  {
    title: 'Hand Cleaning',
    short: 'Gutter, fascia & soffit',
    description:
      'A thorough hand clean to remove black streaks, grime and weathering. UPVC restored to a fresh, clean finish along the whole roofline.',
    icon: 'Sparkles',
  },
  {
    title: 'Roof Moss Removal',
    short: 'Tiles cleaned safely',
    description:
      'Mature moss removed from roof tiles using safe scraping and brushing methods followed by soft wash solution — improving water run-off and preventing tile damage.',
    icon: 'Brush',
  },
];

export const TRUST = [
  { title: 'Fully Insured', detail: 'Comprehensive public liability cover for total peace of mind.' },
  { title: 'Guaranteed Work', detail: 'Every job we complete is guaranteed — we stand behind our workmanship.' },
  { title: 'Free, No-Obligation Quotes', detail: 'Honest pricing and a clear scope before we lift a ladder.' },
];

export const AREAS = [
  'Royal Leamington Spa',
  'Warwick',
  'Kenilworth',
  'Whitnash',
  'Cubbington',
  'Radford Semele',
  'Lillington',
  'Bishops Tachbrook',
  'Hatton',
  'Barford',
  'Harbury',
  'Heathcote',
  'Old Milverton',
  'Offchurch',
  'Hampton Magna',
  'Leek Wootton',
  'Stoneleigh',
];

// Frequently asked questions (used on Home + dedicated FAQ page + JSON-LD)
export const FAQS = [
  {
    q: 'What are the signs my gutters need cleaning?',
    a: 'The clearest signs are water overflowing at the front or back of the gutter during rain, plants or moss growing out of the top, black streaks or drip marks running down your fascia or brickwork, sagging or pulled-away sections, damp patches on interior walls near the roofline and pooling water beside your foundations. If you can see any of these, your gutters need attention before the problem starts damaging your fascia, soffit or masonry.',
  },
  {
    q: 'What property types do you clean gutters on?',
    a: 'We clean gutters on all types of residential property across Leamington Spa and Warwickshire — including terraces, semi-detached and detached houses, bungalows, dormer bungalows, cottages, town houses and larger period properties. We also cover garages, conservatories, extensions, outbuildings and small commercial units such as village shops, cafés and offices. If you\u2019re not sure whether we can help, please call to discuss or send a photo.',
  },
  {
    q: 'How much does gutter cleaning cost in Leamington Spa?',
    a: 'Gutter cleaning in Leamington Spa typically starts from around £45-50 for a small terrace and rises dependant on the size, height and condition of the property. Heavy moss build-up, additions like conservatories or garages, and difficult access can add to the cost. Every quote is free, honest and no-obligation — call Luke on 07788 287 003, or simply send photos on WhatsApp, or fill in the form on the website for a fast estimate.',
  },
  {
    q: 'How do you remove moss from my roof?',
    a: 'Mature moss is removed by hand. We carefully scrape and brush the tiles to lift the moss off without damaging the surface, then clear the debris from the gutters and off the roof. We follow up with a soft-wash biocidal solution that kills the remaining spores and slows regrowth for a much longer period. No high-pressure jetting is used — high-pressure cleaning can crack and lift tiles, so we always use the gentler method that protects your roof.',
  },
  {
    q: 'What is the best time of year to get my gutters cleaned in Leamington Spa?',
    a: 'The two best times to get gutters cleaned are late autumn — after the leaves have fallen from the trees around Leamington Spa, Warwick and Kenilworth — and early spring, before the summer growth begins and before heavy spring rain. Many customers book both an autumn or spring gutter clear out. If your property is close to mature trees you may benefit from a mid-summer clear as well. Regular, annual cleaning is by far the cheapest way to protect your roofline in the long run.',
  },
];

// Real Google / Facebook recommendations supplied by the customer
export const REVIEWS = [
  {
    name: 'Luke Westwood',
    location: 'Recommends Leamington Gutters',
    date: '2 May',
    stars: 5,
    text:
      'Absolutely fantastic service from start to finish! Luke was punctual, professional, and clearly knew exactly what he was doing. They cleaned and repaired our guttering thoroughly, leaving everything working perfectly and looking great. What really stood out was his attention to detail and how tidy they left the area afterward — no mess at all. They also took the time to explain what needed doing and why, which I really appreciated. Highly recommend to anyone needing reliable and high-quality guttering work. I\u2019ll definitely be using them again in the future!',
  },
  {
    name: 'Dawn Chapman',
    location: 'Recommends Leamington Gutters',
    date: '29 November 2025',
    stars: 5,
    text:
      'Very efficient! Repaired my leaking concrete gutter and removed almost a bucket of moss & other debris. Fast & friendly service.',
  },
  {
    name: 'Ann White',
    location: 'Recommends Leamington Gutters',
    date: '24 November 2025',
    stars: 5,
    text:
      'Luke very efficiently mended several leaking joints on my roof gutters, then I decided to have the conservatory roof cleaned, what a difference. Finally all gutters cleaned out, Luke is a cheerful, friendly person and it was lovely to see him do such a good job. Thoroughly recommend.',
  },
  {
    name: 'John Lambe',
    location: 'Recommends Leamington Gutters',
    date: '3 December 2024',
    stars: 5,
    text:
      'A friendly and efficient service, thanks Luke for gutter debris removal at a good price. Recommended.',
  },
  {
    name: 'David Simpson',
    location: 'Recommends Leamington Gutters',
    date: '14 October 2024',
    stars: 5,
    text:
      'Phoned for a quote and left a message after seeing the advert in our local Parish magazine. Luke called me back the same day and after asking for some details and viewing the property on Google maps, I was given a quote to have my gutters and downpipes emptied, front and rear. An appointment was booked and the work was carried out efficiently and to a high standard, and I was delighted with the result. My neighbour also had her gutters cleared at the same time. Luke is friendly and professional and I would not hesitate to recommend Leamington Gutters to anyone. We would definitely use again for gutter, soffit and fascia cleaning.',
  },
];

// Real work photos supplied by Luke (Leamington Gutters)
export const GALLERY = [
  {
    url: '/gallery/ba-moss-gutter.jpg',
    alt: 'Before and after — gutter cleared of heavy moss and weeds',
  },
  {
    url: '/gallery/ba-red-brick-fascia.jpg',
    alt: 'Before and after — fascia and soffit replaced on a red-brick property',
  },
  {
    url: '/gallery/ba-brick-corner.jpg',
    alt: 'Before and after — full UPVC replacement on a brick corner detached',
  },
  {
    url: '/gallery/ba-conservatory-clean.jpg',
    alt: 'Before and after — conservatory roof deep cleaned, transformed from grimy to crystal clear',
  },
  {
    url: '/gallery/conservatory-roof.jpg',
    alt: 'Freshly cleaned polycarbonate conservatory roof under a bright Warwickshire sky',
  },
  {
    url: '/gallery/black-gutter-garden.jpg',
    alt: 'Sleek black UPVC gutter installed alongside aged tiles, overlooking a Warwickshire garden',
  },
  {
    url: '/gallery/concrete-vs-upvc.jpg',
    alt: 'New white UPVC gutter fitted next to the old weathered concrete gutter — clear before and after',
  },
  {
    url: '/gallery/tile-overhang-black-gutter.jpg',
    alt: 'Close-up showing damaged roof tile overhang above newly fitted black UPVC guttering',
  },
  {
    url: '/gallery/new-gutter-clean.jpg',
    alt: 'Crisp white UPVC gutter and fascia freshly fitted on a red-brick home',
  },
  {
    url: '/gallery/20260407_172254.jpg',
    alt: 'Leamington Gutters branded service van outside a semi-detached property',
  },
  {
    url: '/gallery/20250610_101401.jpg',
    alt: 'Tiled roof heavily covered in moss before treatment',
  },
  {
    url: '/gallery/20250520_155043.jpg',
    alt: 'Newly fitted white UPVC fascia and gutter above a garage',
  },
  {
    url: '/gallery/20250922_161751.jpg',
    alt: 'New white UPVC guttering installed along a fascia and brick wall',
  },
  {
    url: '/gallery/20251011_110419.jpg',
    alt: 'Black gutter and downpipe fitted along a tiled roofline',
  },
  {
    url: '/gallery/20250925_121448.jpg',
    alt: 'Roof with solar panels and refurbished guttering and fascia',
  },
];

// Logo crop region from the flyer
export const LOGO_CROP = { left: 4.7, top: 3.8, right: 33.7, bottom: 17.5 };

export const HERO_BG =
  'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?auto=format&fit=crop&w=2000&q=80';
